import React from "react";

import "../../../styles/About/Route/Internships.scss";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Internship from "../../Internship";

import data from "../../../data";

const Internships = ({ darkTheme }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };
  return (
    <>
      <div className="internships">
        <div className="internships__container">
          <div className="internships__header">
            <h2 className="internships__number">
              0<span>3</span>
            </h2>
            <h1
              data-aos="fade-down"
              data-aos-offset="0"
              style={{
                display: "inline-block",
                paddingRight: "0.1em", // Add a bit of padding to prevent clipping
                color: darkTheme ? "white" : "transparent",
                background: darkTheme
                  ? "none"
                  : "linear-gradient(167deg, #79a6d2 21%, #ffb3e6)",
                WebkitBackgroundClip: darkTheme ? "none" : "text",
                WebkitTextFillColor: darkTheme ? "white" : "transparent",
              }}
            >
              I<span>nternships</span>.
            </h1>
            <button
              className="experience__close-button"
              onClick={handleGoBack}
              style={{
                background: "none",
                border: "none",
                color: darkTheme ? "white" : "black",
                cursor: "pointer",
                position: "absolute",
                top: "2px",
                right: "20px",
                padding: "10px", // Increase padding for better clickability
              }}
            >
              <FontAwesomeIcon icon={faTimes} size="xl" />
            </button>
          </div>
          <div
            className="internships__description"
            style={{ color: darkTheme ? "white" : "black" }}
          >
            <div className="internships__main-box">
              {data.portfolio.internships.internship.map((content) => (
                <Internship
                  key={content.companyName}
                  details={content}
                  darkTheme={darkTheme}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Internships;
